import LoginBaseView from './loginBaseView.js';
import resetPasswordFormTemplate from '../../../templates/login/resetPasswordFormTemplate.html';

/*
 * Reset Password View
 * #login
 * TB and JS
 */

const resetPasswordFormView = LoginBaseView.extend({
  className: 'container',
  couldNotResetRenderParams: {
    mainMessage: {
      title: window.lookup('Your password could not be reset'),
      content: window.lookup('Unfortunately, we were unable to reset your password. Please get in touch with our <a href="https://support.sendible.com/">Support Team</a>.'),
    },
    mode: 'message',
  },
  tokenExpiredRenderParams: {
    mainMessage: {
      title: window.lookup('The password reset link is no longer valid'),
      content: window.lookup('Please request another password reset link.'),
    },
    mode: 'message',
  },
  successRenderParams: {
    mode: 'enterEmail',
    message: {
      type: 'success',
      value: window.lookup('If the account exists, you will receive an email within the next few minutes with a link to reset your password.'),
      caption: "Didn't receive the email? Check the spam folder or try again.",
    },
  },
  errorRenderParams: {
    mode: 'enterEmail',
    message: {
      type: 'error',
      value: window.lookup('There was an issue resetting your password, please try again or contact support.'),
    },
  },
  templateDefault: _.template(resetPasswordFormTemplate),
  events: {
    'click button': 'submitResetForm',
    'blur input': 'validateSubmit',
    'keyup input': 'validateSubmit',
    'paste input': 'validateSubmit',
  },

  initialize(options) {
    _.extend(this, options);
  },

  render(options) {
    this.mode = options.mode || this.mode;

    this.$el.html(this.templateDefault(options));
    $('body').html(this.$el);

    this.delegateEvents();

    // if render is not for messages set after form submit then...
    if (this.mode == 'resetPassword' || this.mode == 'enterEmail') {
      // setup scoped element variables
      this.$form = this.$el.find('form');
      this.$inputText = this.$el.find('input[type=email]');
      this.$inputSubmit = this.$el.find('button[type=submit]');
      this.$errorMessages = this.$el.find('.error-messages');
      this.$messageCaption = this.$el.find('.message-caption');
      this.$avatar = this.$el.find('.login-avatar');

      this.$avatar.find('img').attr({ src: window.appConfig.branding.logo_url });

      this.formValidate = this.$form.validate({
        errorClass: 'alert alert-danger',
        errorElement: 'div',
        rules: {
          'reset-inputEmail': {
            required: true,
          },
          email: {
            required: true,
          },
          password: {
            required: true,
            strong_password: true,
          },
          password_confirm: {
            required: true,
            equalTo: '#password',
          },
        },
        messages: {
          password: {
            required: 'Please provide a password',
          },
          password_confirm: {
            required: 'Please provide a password',
            equalTo: 'Please enter the same password as above',
          },
          email: 'Please enter a valid email address',
          'reset-inputEmail': 'Please enter a valid email address',
        },
      });

      // if password reset email cookie is set populate email address
      if (storageUtils.getCookieOrLocalStorageItem('s_loginForm_passwordReset')) {
        this.$inputText.val(storageUtils.getCookieOrLocalStorageItem('s_loginForm_passwordReset'));
        advancedLocalStorage.removeItem('s_loginForm_passwordReset');
      }

      // initialise mailcheck
      this.mailcheck();

      this.validateSubmit();
    }
  },

  enterKeyFilter(e) {
    // filter enter key
    if (e.keyCode != 13) return;
    this.submitResetForm(e);
  },

  validateSubmit(event) {
    // if form validates then enable the submit form
    if (event?.type === 'paste') {
      const clipboardData = (event.clipboardData || window.clipboardData || event.originalEvent.clipboardData);
      const pastedText = clipboardData.getData('text');

      $(event.currentTarget).val(pastedText);
      event.preventDefault();
    }

    this.formValidate.checkForm();

    if (this.formValidate.valid()) {
      this.$inputSubmit.prop('disabled', false);
    } else {
      // if form does not validate then disable the submit form
      this.$inputSubmit.prop('disabled', true);
    }
  },

  setCode(code) {
    this.reset_code = code;
  },

  submitResetForm(e) {
    e.preventDefault();
    // remove errors
    this.$errorMessages.html('');
    this.$messageCaption.html('');

    this.formValidate.form();
    this.validateSubmit();

    if (!this.formValidate.valid()) {
      return false;
    }

    if (this.mode == 'enterEmail') {
      this.submitCaptcha();
    } else if (this.mode == 'resetPassword') {
      this.submitPassword();
    }
  },

  submitCaptcha() {
    if (!this.recaptchaWidgetId || !this.recaptchaDiv || !this.recaptchaDiv.isConnected) {
      this.recaptchaDiv = document.createElement('div');
      const resetButton = document.getElementById('reset-submit');
      resetButton.insertAdjacentElement('afterend', this.recaptchaDiv);

      this.recaptchaWidgetId = grecaptcha.render(this.recaptchaDiv, {
        sitekey: '6LdFlRgpAAAAAJWULmsOAtoPPq7Cs41rB9pqFO-8',
        size: 'invisible',
        callback: this.submitEmail.bind(this),
      });
    }

    grecaptcha.execute(this.recaptchaWidgetId);
  },

  submitEmail(captchaToken) {
    const that = this;
    const email = this.$el.find('input[name=email]').val();
    let locationUrl = '';

    locationUrl = encodeURIComponent(`${window.location.host + window.location.pathname}#forgotmypassword/reset/`);

    // disable submit and provide text feedback
    this.$inputSubmit.text(this.$inputSubmit.data('resetting-text'));
    this.$inputSubmit.prop('disabled', true);

    this.passwordResetXHR = Sendible.Connect.passwordReset(window.appConfig.applicationId, {
      email,
      grecaptchaResponseToken: captchaToken,
      redirect_uri: locationUrl,
    }, (result) => {
      // success
      if (result.result === true) {
        that.render(that.successRenderParams);
      }
    }, this.handleSubmitEmailError.bind(this));
  },

  handleSubmitEmailError() {
    if (this.passwordResetXHR.status === 400) {
      this.render(this.successRenderParams);
    } else {
      this.render(this.errorRenderParams);
    }
    this.$inputSubmit.text(this.$inputSubmit.data('default-text'));
    this.$inputSubmit.prop('disabled', true);
  },

  submitPassword() {
    const that = this;
    const email = this.$el.find('input[name=email]').val();
    const password = this.$el.find('#password').val();

    // disable submit and provide text feedback
    this.$inputSubmit.text(this.$inputSubmit.data('resetting-text'));
    this.$inputSubmit.prop('disabled', true);

    Sendible.Connect.passwordSet(window.appConfig.applicationId, {
      access_token: this.reset_code,
      email,
      password,
    }, (result) => {
      // success
      if (result.result === true) {
        that.options.parent.navigate('login/passwordReset', { trigger: true, replace: true });
      }
    }, (result) => {
      if (result && result.error && result.error.message === 'Requested access token is not valid.') {
        that.render(that.tokenExpiredRenderParams);
      } else {
        that.render(that.couldNotResetRenderParams);
      }
    });
  },

  cleanup() {
    clearInterval(this.checkInterval);

    this.unbind();
    this.remove();
  },

});

export default resetPasswordFormView;
